module.exports = __webpack_public_path__ + "img/trash.51fb0f22.png";